import { observable } from 'mobx';

class SeasonStore {
  @observable seasonList = [];
  @observable loaded = false;
  @observable selectedSeason = 0;
}

export default new SeasonStore();
